import React, { useState, useEffect } from "react";

const DiscussionQuestionGenerator = ({ questions = [], title }) => {
  const [unusedQuestions, setUnusedQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(
    "Click the button to get a question!"
  );

  // Load questions into the "unused" pool when the component mounts or questions change
  useEffect(() => {
    if (questions && questions.length > 0) {
      setUnusedQuestions([...questions]);
    }
  }, [questions]);

  const getRandomQuestion = () => {
    if (!questions || questions.length === 0) {
      setCurrentQuestion("No questions available.");
      return;
    }

    let currentPool = [...unusedQuestions];

    // If we ran out of questions, reset the pool from the original list
    if (currentPool.length === 0) {
      currentPool = [...questions];
    }

    const randomIndex = Math.floor(Math.random() * currentPool.length);
    const selected = currentPool[randomIndex];

    // Remove the selected question so we don't repeat it immediately
    currentPool.splice(randomIndex, 1);
    setUnusedQuestions(currentPool);

    setCurrentQuestion(selected.text);
  };

  return (
    <div className="discussion-generator-card" style={{
      textAlign: "center",
      padding: "40px 20px",
      backgroundColor: "#fcfcfc",
      border: "2px dashed #ccc",
      borderRadius: "15px",
      marginTop: "20px"
    }}>
      <h2 style={{ marginBottom: "20px" }}>{title || "Discussion Questions"}</h2>
      
      <div style={{ 
        fontSize: "1.4rem", 
        minHeight: "100px", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        padding: "0 20px",
        color: "#333",
        lineHeight: "1.4"
      }}>
        {currentQuestion}
      </div>

      <button
        onClick={getRandomQuestion}
        style={{
          marginTop: "30px",
          padding: "15px 30px",
          fontSize: "1.1rem",
          backgroundColor: "#ff7675",
          color: "white",
          border: "none",
          borderRadius: "50px",
          cursor: "pointer",
          fontWeight: "bold",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
        }}
      >
        Get a Random Question
      </button>
      
      <p style={{ marginTop: "15px", fontSize: "0.8rem", color: "#888" }}>
        {unusedQuestions.length} questions remaining in the deck
      </p>
    </div>
  );
};

export default DiscussionQuestionGenerator;
